import { render, staticRenderFns } from "./individualization.vue?vue&type=template&id=4ffff480&scoped=true&"
import script from "./individualization.vue?vue&type=script&lang=js&"
export * from "./individualization.vue?vue&type=script&lang=js&"
import style0 from "./individualization.vue?vue&type=style&index=0&id=4ffff480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffff480",
  null
  
)

export default component.exports